import type { ISafeAreaInsets } from '../types';

export const validateSafeAreaInsets = (insets: unknown): insets is ISafeAreaInsets => {
  if (typeof insets !== 'object' || insets === null) return false;
  const insetsObj = insets as ISafeAreaInsets;
  return (
    typeof insetsObj.top === 'number' &&
    typeof insetsObj.right === 'number' &&
    typeof insetsObj.bottom === 'number' &&
    typeof insetsObj.left === 'number'
  );
};
